import { useEffect } from "react";

const useAudioUnlock = () => {
    useEffect(() => {
        const unlockAudio = () => {
            const unlockUtterance = new SpeechSynthesisUtterance("");
            unlockUtterance.volume = 0;
            window.speechSynthesis?.speak(unlockUtterance);
            document.removeEventListener("click", unlockAudio);
        };
        document.addEventListener("click", unlockAudio);

        return () => {
            document.removeEventListener("click", unlockAudio);
        };
    }, []);
};

export default useAudioUnlock;